module.exports = __webpack_public_path__ + "img/58.b2026d18.jpg";